import { useParams } from 'react-router-dom'

interface IParams {
  moduleId: string
  courseId: string
  lessonId: string
  chapterId: string
}

export const useLessonParams = () => useParams<IParams>()
